import { enumsState } from './enums.state';
import { enumsActions } from './enums.actions';
import { enumsGetters } from './enums.getters';
import { enumsMutations } from './enums.mutations';

export default {
  state: enumsState,
  actions: enumsActions,
  getters: enumsGetters,
  mutations: enumsMutations,
};
